
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser'
export { Prisma }
export * as $Enums from './enums'
export * from './enums';
/**
 * Model Company
 * 
 */
export type Company = Prisma.CompanyModel
/**
 * Model Department
 * 
 */
export type Department = Prisma.DepartmentModel
/**
 * Model Users
 * 
 */
export type Users = Prisma.UsersModel
/**
 * Model UserRoles
 * 
 */
export type UserRoles = Prisma.UserRolesModel
/**
 * Model DepartmentUsers
 * 
 */
export type DepartmentUsers = Prisma.DepartmentUsersModel
/**
 * Model JobPosting
 * 
 */
export type JobPosting = Prisma.JobPostingModel
/**
 * Model JobApplication
 * 
 */
export type JobApplication = Prisma.JobApplicationModel
/**
 * Model JobApplicationDocument
 * 
 */
export type JobApplicationDocument = Prisma.JobApplicationDocumentModel
/**
 * Model JobApplicationCandidateDetails
 * 
 */
export type JobApplicationCandidateDetails = Prisma.JobApplicationCandidateDetailsModel
/**
 * Model Candidate
 * 
 */
export type Candidate = Prisma.CandidateModel
/**
 * Model CandidateExperience
 * 
 */
export type CandidateExperience = Prisma.CandidateExperienceModel
/**
 * Model CandidateExperienceRole
 * 
 */
export type CandidateExperienceRole = Prisma.CandidateExperienceRoleModel
/**
 * Model CandidateExperienceProject
 * 
 */
export type CandidateExperienceProject = Prisma.CandidateExperienceProjectModel
/**
 * Model CandidateQualification
 * 
 */
export type CandidateQualification = Prisma.CandidateQualificationModel
/**
 * Model CandidateSkill
 * 
 */
export type CandidateSkill = Prisma.CandidateSkillModel
/**
 * Model Source
 * 
 */
export type Source = Prisma.SourceModel
/**
 * Model WhatsAppHistory
 * 
 */
export type WhatsAppHistory = Prisma.WhatsAppHistoryModel
/**
 * Model Metrics
 * 
 */
export type Metrics = Prisma.MetricsModel
/**
 * Model Interview
 * 
 */
export type Interview = Prisma.InterviewModel
/**
 * Model InterviewRound
 * 
 */
export type InterviewRound = Prisma.InterviewRoundModel
/**
 * Model PanellistFeedback
 * 
 */
export type PanellistFeedback = Prisma.PanellistFeedbackModel
/**
 * Model AssessmentTemplate
 * 
 */
export type AssessmentTemplate = Prisma.AssessmentTemplateModel
/**
 * Model AssessmentParameter
 * 
 */
export type AssessmentParameter = Prisma.AssessmentParameterModel
/**
 * Model AssessmentTemplateParameters
 * 
 */
export type AssessmentTemplateParameters = Prisma.AssessmentTemplateParametersModel
/**
 * Model ParameterRating
 * 
 */
export type ParameterRating = Prisma.ParameterRatingModel
/**
 * Model InterviewPanelistParameterAssignment
 * 
 */
export type InterviewPanelistParameterAssignment = Prisma.InterviewPanelistParameterAssignmentModel
/**
 * Model ScreeningInterview
 * 
 */
export type ScreeningInterview = Prisma.ScreeningInterviewModel
/**
 * Model ScreeningCall
 * 
 */
export type ScreeningCall = Prisma.ScreeningCallModel
/**
 * Model PhoneCallLifecycleEvent
 * 
 */
export type PhoneCallLifecycleEvent = Prisma.PhoneCallLifecycleEventModel
/**
 * Model ScreeningResult
 * 
 */
export type ScreeningResult = Prisma.ScreeningResultModel
/**
 * Model ScreeningSystemMessages
 * 
 */
export type ScreeningSystemMessages = Prisma.ScreeningSystemMessagesModel
/**
 * Model SystemSettings
 * 
 */
export type SystemSettings = Prisma.SystemSettingsModel
/**
 * Model InterviewResult
 * 
 */
export type InterviewResult = Prisma.InterviewResultModel
/**
 * Model ScreeningResultCategories
 * 
 */
export type ScreeningResultCategories = Prisma.ScreeningResultCategoriesModel
/**
 * Model CompanyConfig
 * 
 */
export type CompanyConfig = Prisma.CompanyConfigModel
/**
 * Model Integration
 * 
 */
export type Integration = Prisma.IntegrationModel
/**
 * Model CustomFieldDefinition
 * 
 */
export type CustomFieldDefinition = Prisma.CustomFieldDefinitionModel
/**
 * Model DefaultApprovers
 * 
 */
export type DefaultApprovers = Prisma.DefaultApproversModel
/**
 * Model JobApprovers
 * 
 */
export type JobApprovers = Prisma.JobApproversModel
/**
 * Model ApprovalRoutingRule
 * 
 */
export type ApprovalRoutingRule = Prisma.ApprovalRoutingRuleModel
/**
 * Model ApprovalRoutingApprover
 * 
 */
export type ApprovalRoutingApprover = Prisma.ApprovalRoutingApproverModel
/**
 * Model Approvals
 * 
 */
export type Approvals = Prisma.ApprovalsModel
/**
 * Model JobOffers
 * 
 */
export type JobOffers = Prisma.JobOffersModel
/**
 * Model JobOfferDocuments
 * 
 */
export type JobOfferDocuments = Prisma.JobOfferDocumentsModel
/**
 * Model Notification
 * 
 */
export type Notification = Prisma.NotificationModel
/**
 * Model DailyWebhookEvent
 * 
 */
export type DailyWebhookEvent = Prisma.DailyWebhookEventModel
/**
 * Model candidateNotes
 * 
 */
export type candidateNotes = Prisma.candidateNotesModel
/**
 * Model JobOpenings
 * 
 */
export type JobOpenings = Prisma.JobOpeningsModel
/**
 * Model OfferTemplateDocuments
 * 
 */
export type OfferTemplateDocuments = Prisma.OfferTemplateDocumentsModel
/**
 * Model FaceLivenessVerification
 * 
 */
export type FaceLivenessVerification = Prisma.FaceLivenessVerificationModel
/**
 * Model SearchTriggerErrors
 * 
 */
export type SearchTriggerErrors = Prisma.SearchTriggerErrorsModel
/**
 * Model candidate_search_trigger_errors
 * 
 */
export type candidate_search_trigger_errors = Prisma.candidate_search_trigger_errorsModel
/**
 * Model StatusChangeMetrics
 * 
 */
export type StatusChangeMetrics = Prisma.StatusChangeMetricsModel
/**
 * Model AdminAuditLogs
 * 
 */
export type AdminAuditLogs = Prisma.AdminAuditLogsModel
/**
 * Model CustomChartConfig
 * 
 */
export type CustomChartConfig = Prisma.CustomChartConfigModel
/**
 * Model Embedding
 * 
 */
export type Embedding = Prisma.EmbeddingModel
/**
 * Model JobDescription
 * 
 */
export type JobDescription = Prisma.JobDescriptionModel
/**
 * Model JDLangGraphState
 * 
 */
export type JDLangGraphState = Prisma.JDLangGraphStateModel
/**
 * Model ReferenceJD
 * 
 */
export type ReferenceJD = Prisma.ReferenceJDModel
/**
 * Model InviteResponse
 * 
 */
export type InviteResponse = Prisma.InviteResponseModel
/**
 * Model InterviewDeclineNotification
 * 
 */
export type InterviewDeclineNotification = Prisma.InterviewDeclineNotificationModel
/**
 * Model DocumentRequests
 * 
 */
export type DocumentRequests = Prisma.DocumentRequestsModel
/**
 * Model CandidateSharing
 * 
 */
export type CandidateSharing = Prisma.CandidateSharingModel
/**
 * Model TalentPoolJobInvite
 * 
 */
export type TalentPoolJobInvite = Prisma.TalentPoolJobInviteModel
/**
 * Model JobSourcedCandidate
 * Sourcing extension (INT-547): a person added to a job's Sourced list. Not a candidate or an application until
 * they apply through the invite link or are moved to Applications.
 */
export type JobSourcedCandidate = Prisma.JobSourcedCandidateModel
/**
 * Model JDAgentConversation
 * 
 */
export type JDAgentConversation = Prisma.JDAgentConversationModel
/**
 * Model CommunicationServiceStatus
 * 
 */
export type CommunicationServiceStatus = Prisma.CommunicationServiceStatusModel
/**
 * Model CommunicationTemplate
 * 
 */
export type CommunicationTemplate = Prisma.CommunicationTemplateModel
/**
 * Model BillingCreditCostSet
 * Named catalog of per-action credit costs. Assignable to plans and (as override) companies.
 */
export type BillingCreditCostSet = Prisma.BillingCreditCostSetModel
/**
 * Model BillingPlan
 * Catalog plan for subscriptions / freemium. Source of truth for Stripe Product/Price sync.
 */
export type BillingPlan = Prisma.BillingPlanModel
/**
 * Model CompanyCreditBalance
 * Mutable credit wallet per company (included allotment + prepaid packs).
 */
export type CompanyCreditBalance = Prisma.CompanyCreditBalanceModel
/**
 * Model BillingCreditLedger
 * Append-only wallet ledger (holds, debits, grants, packs). Separate from BillingEventLedger.
 */
export type BillingCreditLedger = Prisma.BillingCreditLedgerModel
/**
 * Model BillingSubscription
 * 
 */
export type BillingSubscription = Prisma.BillingSubscriptionModel
/**
 * Model BillingCapacityGrant
 * Resume-parse capacity allotment increases (legacy; new billing uses prepaid credit packs).
 */
export type BillingCapacityGrant = Prisma.BillingCapacityGrantModel
/**
 * Model BillingSignupDraft
 * 
 */
export type BillingSignupDraft = Prisma.BillingSignupDraftModel
/**
 * Model OneTimePassword
 * Hashed one-time passwords keyed by purpose + subject (e.g. signup draft id).
 */
export type OneTimePassword = Prisma.OneTimePasswordModel
/**
 * Model BillingEventLedger
 * 
 */
export type BillingEventLedger = Prisma.BillingEventLedgerModel
/**
 * Model InterviewQualityReport
 * 
 */
export type InterviewQualityReport = Prisma.InterviewQualityReportModel
/**
 * Model InterviewQualityIssue
 * 
 */
export type InterviewQualityIssue = Prisma.InterviewQualityIssueModel
/**
 * Model InterviewQualityRun
 * 
 */
export type InterviewQualityRun = Prisma.InterviewQualityRunModel
